import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import router from './router';
import 'dayjs/locale/zh-cn';
import './App.css';

function App() {
  return (
    <AntApp>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: '#667eea',
            borderRadius: 8,
            fontSize: 14,
          },
          components: {
            Button: {
              controlHeight: 36,
            },
            Input: {
              controlHeight: 36,
            },
          },
        }}
      >
        <RouterProvider router={router} />
      </ConfigProvider>
    </AntApp>
  );
}

export default App;
